module.exports = __webpack_public_path__ + "img/1998.dc5502b0.jpg";